import TargetGroup from './TargetGroup';

export default TargetGroup;
